import { amplitude } from "@eis-poc/lib-discover-medical-mfes";

export const EVENTS = {
  navigationClicked: "Navigation Item - clicked",
  systemCheckRunClicked: "System Check - run_test_clicked",
  unauthorizedViewed: "Unauthorized - viewed",
  assistantInitiated: "Watson - widget_initiated",
  assistantNavigateClicked: "Watson - navigate_clicked"
};

export const AFFORDANCE = {
  mainMenu: "main-menu",
  results: "results",
  productTab: "product-tab",
  footer: "footer"
};

export const NAVIGATE_TO = {
  ebmr: "Ebsco Research",
  dcd: "DCD",
  mobile: "mobile"
};

export const logNavigationClicked = ({
  affordance,
  navigateTo,
  navigateFrom
}) => {
  amplitude.log(EVENTS.navigationClicked, {
    affordance,
    navigate_to: navigateTo,
    navigate_from: navigateFrom
  });
};

export const logAssistantInitiated = (currentUrl) => {
  amplitude.log(EVENTS.assistantInitiated, {
    path: currentUrl
  });
};
export const logAssistantNavigateClicked = (affordance) => {
  amplitude.log(EVENTS.assistantNavigateClicked, {
    affordance: affordance
  });
};

export const logSystemCheckRunClicked = () => {
  amplitude.log(EVENTS.systemCheckRunClicked, {});
};

export const logUnauthorizedViewed = () => {
  if (typeof window !== "undefined") {
    amplitude.log(EVENTS.unauthorizedViewed, { url: window.location.pathname });
  }
};

/**
 * Let us send event to Amplitude using "log" function, when initialization of Amplitude
 * is not finished yet or logEvent called before Amplitude initialization.
 *
 * @param log - function that send event to amplitude
 * @example - logEvent(logUnauthorizedViewed);
 */
export const logEvent = (log) => {
  const maxAttempts = 5;
  const timeout = 500;
  let cycleNumber = 0;

  const sendEvent = () => {
    if (!amplitude.isInitialized() && cycleNumber < maxAttempts) {
      cycleNumber++;
      setTimeout(sendEvent, timeout);
    } else {
      log();
    }
  };
  sendEvent();
};
